import { SAMPLE_STATUSES, SAMPLE_STATUSES_DESC } from '@/config/constants';
import sampleReports from '@/services/sampleReports';
import acl from '@/services/acl';

// The eye opens the sample's progress when it has one the user may see, its analyses otherwise.
const opensProgress = row => !!row.progress?.hasProgress && acl.userCanUse(['progressView']);

const samplesColumns = {
  orderId: {
    key: 'orderId',
    label: 'orderId',
    type: 'text',
    sortable: true,
    minWidth: '80px',
  },
  order: {
    key: 'orderTitle',
    label: 'orderName',
    type: 'text',
    sortable: true,
    minWidth: '130px',
  },
  sampleId: {
    key: 'id',
    label: 'sampleId',
    type: 'text',
    sortable: true,
    minWidth: '110px',
  },
  lot: {
    key: 'lot',
    label: 'lot',
    type: 'text',
    sortable: true,
    minWidth: '100px',
  },
  productCode: {
    key: 'productCode',
    label: 'productCode',
    type: 'text',
    sortable: true,
    minWidth: '120px',
  },
  productName: {
    key: 'productName',
    label: 'productName',
    type: 'text',
    sortable: true,
    minWidth: '130px',
  },
  customerProductName: {
    key: 'customerProductName',
    label: 'customerProductName',
    type: 'text',
    sortable: true,
    minWidth: '110px',
  },
  deliveryDate: {
    key: 'deliveryDates',
    fallbackKey: 'deliveryDate',
    label: 'deliveryDate',
    type: 'stacked-dates',
    sortable: 'custom',
    minWidth: '120px',
    help: 'deliveryDateTooltip',
  },
  reportCode: {
    key: 'sampleReportCodes',
    label: 'reportCode',
    type: 'stacked-text',
    sortable: true,
    minWidth: '120px',
  },
  reportsList: {
    key: 'reports',
    label: 'reportsList',
    type: 'slot-collapse-list',
    collapseTitle: 'samples.showReportsList',
    collapseKey: 'reports',
    collapseValue: 'laboratory',
    collapseAddon: 'status',
    collapseItemLabel: sampleReports.reportLabelKey,
    collapseItemIcon: 'download',
    sortable: false,
    minWidth: '160px',
  },
  status: {
    key: 'status',
    label: 'status',
    type: 'encoded',
    minWidth: 70,
    align: 'center',
    sortable: true,
    customClass: true,
    enum: 'sampleStatuses',
    decode: value => SAMPLE_STATUSES_DESC[value],
    getClassModifier: value => SAMPLE_STATUSES_DESC[value],
  },
  rejectReason: {
    key: 'rejectReason',
    label: 'rejectReason',
    type: 'text',
    sortable: false,
    minWidth: '100px',
  },
  actions: {
    label: 'actions',
    type: 'actions',
    sortable: false,
    fixed: 'right',
    minWidth: '165px',
    align: 'center',
    buttons: [
      {
        name: 'showAnalyses',
        icon: 'fas fa-eye',
        color: 'sand',
        showCondition: row => !opensProgress(row),
      },
      {
        name: 'showProgress',
        icon: 'fas fa-eye',
        color: 'sand',
        permissions: ['progressView'],
        showCondition: opensProgress,
      },
      {
        name: 'editSample',
        icon: 'fas fa-pencil',
        color: 'blue-light',
        permissions: ['user', 'ordersManage'],
        showCondition: row => row.status === SAMPLE_STATUSES.CREATED,
      },
      {
        name: 'deleteSample',
        icon: 'fas fa-minus-circle',
        color: 'red-light',
        permissions: ['user', 'ordersManage'],
        showCondition: row => row.status === SAMPLE_STATUSES.CREATED,
      },
      {
        name: 'addAnalyses',
        icon: 'fas fa-plus',
        color: 'gray',
        permissions: ['user', 'ordersManage'],
        showCondition: row => row.status === SAMPLE_STATUSES.PENDING,
      },
      {
        name: 'renameSample',
        icon: 'fas fa-pencil',
        color: 'green',
        permissions: ['user', 'ordersManage'],
        showCondition: row => row.status === SAMPLE_STATUSES.DRAFT,
      },
      {
        name: 'downloadSampleReport',
        icon: 'fas fa-download',
        color: 'green',
        permissions: ['user', 'ordersManage'],
        showCondition: row => row.reports && row.reports.length > 1 && row.reports[0].id,
      },
    ],
  },
};

export default samplesColumns;
